import { collection } from "firebase/firestore";
import { db } from "src/features/firebase/firestore/utils";

const getInvitesCollection = () => collection(db, `invites`);

export { getInvitesCollection };
